<template>
  <ul class="nav nav-mobile-menu my-0 py-0">
    <!--<drop-down>
      <template slot="title">
        <i class="fa fa-globe"></i>
        <b class="caret"></b>
        <span class="notification">5 Notifications</span>
      </template>
      <a class="dropdown-item" href="#">Notification 1</a>
      <a class="dropdown-item" href="#">Notification 2</a>
      <a class="dropdown-item" href="#">Notification 3</a>
      <a class="dropdown-item" href="#">Notification 4</a>
      <a class="dropdown-item" href="#">Another notification</a>
    </drop-down>
    <li class="nav-item">
      <a href="#" class="nav-link">
        <i class="nc-icon nc-zoom-split hidden-lg-up"></i>
        <span class="d-lg-none">Search</span>
      </a>
    </li>
    <drop-down title="Dropdown">
      <a class="dropdown-item" href="#">Action</a>
      <a class="dropdown-item" href="#">Another action</a>
      <a class="dropdown-item" href="#">Something</a>
      <a class="dropdown-item" href="#">Something else here</a>
      <div class="divider"></div>
      <a class="dropdown-item" href="#">Separated link</a>
    </drop-down>-->

    <li class="nav-item">
      <!--<a class="nav-link" href="#pablo">-->
        <!--<span class="no-icon">Log out</span>-->
      <!--</a>-->
        <a @click="logout" class="nav-link" style="cursor: pointer">
            <i class="nc-icon nc-button-power"></i> logout
        </a>
    </li>
  </ul>
</template>
<script>
//  import DropDown from 'src/components/UIComponents/Dropdown.vue'

  export default {
//    components: {
//        DropDown
//    },
    methods:{
        logout(){
            this.$store.dispatch('AUTH_LOGOUT').then(res => this.$router.push('/login'))
        }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/MobileMenu.vue